
export const KeyStatus = {
  NO_KEY_INFO: 0,
  NOT_AVAILABLE: 1,
  NOT_BACKUP: 2,
  DIDNOT_BORROW: 3,
  IS_BORROWED: 4,
  IS_RETURNED: 5,
};
